import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { sendPasswordChangeRequest } from "../../auth/auth";
import { useNavigate } from "react-router-dom";
import styles from "./PasswordChange.module.css";

function PasswordChange() {
  const [username, setUsername] = useState("");
  const [passwordResetCode, setPasswordResetCode] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showVerifyPassword, setShowVerifyPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== verifyPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const response = await sendPasswordChangeRequest(
        username,
        password,
        passwordResetCode
      );
      console.log(response);
      alert(response.data.success);
      navigate("/");
    } catch (error) {
      console.error("Error sending password change request:", error);
      alert(error.response.data.error);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <form className={styles.passwordChangeForm}>
        <h1>Password Reset</h1>
        <div className={styles.passwordChangeFormText}>
          <p>Enter the information below.</p>
          <p>
            For your new password, it is recommend that you use your Deltek
            password.
          </p>
        </div>

        <label htmlFor="username">Username:</label>
        <input
          type="text"
          id="username"
          name="username"
          value={username}
          autoComplete="username"
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <label htmlFor="password-reset-code">Password Reset Code:</label>
        <input
          type="text"
          id="password-reset-code"
          name="password-reset-code"
          value={passwordResetCode}
          autoComplete="password-reset-code"
          onChange={(e) => setPasswordResetCode(e.target.value)}
          required
        />

        <label htmlFor="password">New Password:</label>
        <div className={styles.passwordInputContainer}>
          <input
            type={showPassword ? "text" : "password"}
            id="new-password"
            name="new-password"
            value={password}
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className={styles.showPasswordButton}
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <label htmlFor="verify-password">Verify New Password:</label>
        <div className={styles.passwordInputContainer}>
          <input
            type={showVerifyPassword ? "text" : "password"}
            id="verify-password"
            name="new-password"
            value={verifyPassword}
            autoComplete="new-password"
            onChange={(e) => setVerifyPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className={styles.showPasswordButton}
            onClick={() => setShowVerifyPassword(!showVerifyPassword)}
            aria-label={showVerifyPassword ? "Hide password" : "Show password"}
          >
            {showVerifyPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        <div className={styles["button_container"]}>
          <button
            type="submit"
            className={styles["password_reset_button"]}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default PasswordChange;
